import { useState } from 'react'

import { Info, X } from 'lucide-react'

import OpenInBrowserActions from '../OpenInBrowserActions'

// Early, dismissible warning when the form looks like it is open inside an email or social
// app. It doesn't block anything: the camera check before Veriff is the hard stop.
const InAppBrowserBanner = ({ onAction }) => {

    const [dismissed, setDismissed] = useState(false)

    if (dismissed) return null

    return (
        <div className="mx-4 mt-3 rounded-xl border border-amber-200 bg-amber-50 p-4 text-amber-900">
            <div className="flex items-start gap-3">
                <Info className="w-5 h-5 shrink-0 mt-0.5" />
                <div className="flex-1 space-y-3">
                    <div>
                        <p className="font-semibold">This page is open inside another app</p>
                        <p className="text-sm">
                            Identity verification needs your camera, which often doesn't work inside
                            email apps. For the best experience, open this page in your browser.
                        </p>
                    </div>
                    <OpenInBrowserActions onAction={onAction} compact />
                </div>
                <button
                    type="button"
                    onClick={() => setDismissed(true)}
                    aria-label="Dismiss"
                    className="p-1 rounded hover:bg-amber-100"
                >
                    <X className="w-4 h-4" />
                </button>
            </div>
        </div>
    )
}

export default InAppBrowserBanner
